import {Module} from "../index";
import {Scout} from "@/modules/scouting/entity";
import {ScoutFactory} from "@/modules/scouting/factories/ScoutFactory";
import messages from "./resources/messages";
import {AbstractStaffMemberFactory} from "@/modules/staff/services/factories/AbstractStaffMemberFactory";
import {TYPES as STAFF_TYPES} from "@/modules/staff/types";

export class ScoutingModule extends Module {
  messages = messages;

  public entities = [
    Scout,
  ];

  protected register() {
    super.register();

    this.app.bind<ScoutFactory>(ScoutFactory).to(ScoutFactory);

    this.app.bind<AbstractStaffMemberFactory>(STAFF_TYPES.StaffMemberFactory).to(ScoutFactory);
  }
}
